<template>
  <div class="container">
    <vx-card class="mt-5" title="Lista Negra">
      <vs-row>
        <vs-col vs-w="2">
          <vs-button @click="openDialogHandler" color="primary" variant="flat">
            Agregar registro
          </vs-button>
        </vs-col>
        <vs-col vs-w="3">
          <vs-input
              @keyup.enter="searchHandler"
              class="w-full"
              v-model="search"
              icon="search"
              placeholder="Buscar"/>
        </vs-col>
      </vs-row>

      <vs-table
          class="mt-5"
          :data="blackListItems"
          stripe
          no-data-text="Agregue un criterio de busqueda">
        <template slot="thead">
          <vs-th>Naturaleza</vs-th>
          <vs-th>Tipo de persona</vs-th>
          <vs-th>Nombre</vs-th>
          <vs-th>RFC</vs-th>
          <vs-th>CURP</vs-th>
          <vs-th>Dirección</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr v-for="d in data">
            <vs-td>{{ d.nature }}</vs-td>
            <vs-td>
              <vs-chip>{{ d.person_type }}</vs-chip>
            </vs-td>
            <vs-td>{{ d.name }} {{ d.last_name_1 }} {{ d.last_name_2 }}</vs-td>
            <vs-td>{{ d.rfc }}</vs-td>
            <vs-td>{{ d.curp }}</vs-td>
            <vs-td>{{ d.address }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>

    <vs-popup title="Nuevo registro" :active.sync="showDialog">
      <div class="grid grid-cols-2 gap-4">
        <vs-select
            v-validate="'required'"
            label="Tipo persona"
            name="tipo_persona"
            class="w-full"
            v-model="form.person_type">
          <vs-select-item key="1" text="Persona física mexicana" value="pf_mex"/>
          <vs-select-item key="2" text="Persona moral mexicana" value="pm_mex"/>
        </vs-select>

        <vs-input
            :danger="errors.has('naturaleza')"
            :danger-text="errors.first('naturaleza')"
            v-validate="'required'"
            name="naturaleza"
            class="w-full"
            label="Naturaleza"
            disabled="disabled"
            v-model="form.nature"></vs-input>

        <vs-input
            :danger="errors.has('name')"
            :danger-text="errors.first('name')"
            v-validate="'required'"
            name="name"
            class="w-full"
            label="Nombre"
            v-model="form.name"></vs-input>

        <template v-if="form.person_type === 'pf_mex'">
          <vs-input class="w-full" name="last_name_1" label="Apellido paterno" v-model="form.last_name_1"></vs-input>
          <vs-input class="w-full" name="last_name_2" label="Apellido materno" v-model="form.last_name_2"></vs-input>
          <vs-input
              :danger="errors.has('curp')"
              :danger-text="errors.first('curp')"
              v-validate="'required'"
              class="w-full"
              name="curp"
              label="CURP"
              v-model="form.curp"></vs-input>
        </template>

        <vs-input
            :danger="errors.has('rfc')"
            :danger-text="errors.first('rfc')"
            v-validate="'required'"
            name="rfc"
            class="w-full"
            label="RFC"
            v-model="form.rfc"></vs-input>

        <vs-input
            :danger="errors.has('complementary')"
            :danger-text="errors.first('complementary')"
            v-validate="'required'"
            name="complementary"
            class="w-full"
            label="Complemento"
            v-model="form.complementary"></vs-input>

      </div>
      <vs-button class="mt-5 float-right" :disabled="errors.count() > 0" @click="savePersonHandler">
        Guardar
      </vs-button>
    </vs-popup>
  </div>
</template>

<script>
export default {
  name: "BlackListView",
  data: () => ({
    search: "",
    showDialog: false,
    blackListItems: [],
    form: {
      person_type: "pf_mex",
      name: "",
      last_name_1: null,
      last_name_2: null,
      rfc: "",
      curp: "",
      complementary: "",
      nature: "stp_fraud",
    },
    formError: null
  }),
  methods: {
    async openDialogHandler() {
      this.showDialog = true
      await this.$validator.validate()
    },
    async searchHandler() {
      this.$vs.loading()

      try {
        const {data} = await axios.post('/api/fraud-prevention/black-list/search', {
          q: this.search
        })

        this.blackListItems = data;
      } catch (e) {
        this.$vs.loading.close()
      } finally {
        this.$vs.loading.close()
      }
    },
    async savePersonHandler() {
      this.$vs.loading()

      try {
        await axios.post('/api/fraud-prevention/black-list', this.form)
        this.showDialog = false
        this.$vs.notify({
          title: "Éxito",
          text: "Se ha guardado el registro",
          color: "success"
        })
      } catch (e) {
        this.$vs.notify({
          title: "Error",
          text: "No se ha podido guardar el registro",
          color: "danger"
        })
      } finally {
        this.$vs.loading.close()
      }
    }
  }
}
</script>

<style scoped>

</style>